import { AllNodesValidationStates } from "@features/builder/graph/nodes/validation/types"
import { atom } from "jotai"

export const nodesValidationAtom = atom<AllNodesValidationStates>({})

/**
 * Write-only helper atom used by the validation worker.
 *
 * It merges partial validation results into the existing per-node state instead of
 * replacing the whole object, and lets callers write without subscribing to
 * `nodesValidationAtom` reads.
 */
export const mergeNodesValidationAtom = atom(
  null,
  (get, set, results: AllNodesValidationStates) => {
    const current = get(nodesValidationAtom)
    const next: AllNodesValidationStates = { ...current }

    for (const [nodeId, validations] of Object.entries(results)) {
      // Deep clone is unnecessary here: validation payloads are treated as immutable snapshots.
      next[nodeId] = {
        ...(current[nodeId] ?? {}),
        ...validations,
      }
    }

    set(nodesValidationAtom, next)
  },
)

if (process.env.NODE_ENV !== "production") {
  nodesValidationAtom.debugLabel = "nodesValidationAtom"
  mergeNodesValidationAtom.debugLabel = "mergeNodesValidationAtom"
}
